import { useAppSelector } from "../../store/hooks";

// Заглавието на справката „Асортименти": в режим „със склад"
// (organizations.uses_warehouse, идва от GET /user/info) продаваемото е
// рецепта, затова същата справка се казва „Справка по рецепти".
// Ползва се на трите места, които показват името — таба (Reports.tsx),
// sidebar-а и хедъра/Excel експорта на самата справка.
export const useAssortmentReportTitleKey = (): string => {
  const usesWarehouse = useAppSelector(
    (s) => s.auth.user?.uses_warehouse === true,
  );

  return usesWarehouse
    ? "reportsPage.recipesReport"
    : "reportsPage.assortmentReport";
};
